webpackJsonp([28],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hobbit = this.el.querySelector("#hobbit-hobbit");
      var man = this.el.querySelector("#hobbit-man");
      var scale = this.el.querySelector("#hobbit-scale");

      this.animation = new TimelineMax({
        repeat: -1,
        repeatDelay: 1.7,
        yoyo: true
      }).to(hobbit, 1, { x: 60, scale: 0.7, transformOrigin: "bottom", delay: 1 }).to([man, scale], 1, { opacity: 0.45 });

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300",
          fill: "#7CB342"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "hobbit-scale", opacity: "0" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M443.56 452.44h40.14v29.07h-40.14z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(443.56 476.03)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "1\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M442.84 374.13h26.36v26.55h-26.36z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(442.84 397.717)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "2\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M442.87 293.16h56.75V325h-56.75z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(442.87 316.75)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "3\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M442.9 213.45h52.6v34.61h-52.6z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(442.897 237.038)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "4\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M442.87 133.74h33.22v37.37h-33.22z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(442.87 157.327)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "5\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "none", d: "M444.95 56.1h29.07v35.99h-29.07z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            {
              transform: "translate(444.944 79.69)",
              fill: "#33691E",
              fontFamily: "Arial",
              fontSize: "33.223"
            },
            "6\u2019"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { fill: "none", stroke: "#33691E", strokeWidth: "3", strokeMiterlimit: "10" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M130.79 544.06h306.42M130.79 465.73h306.42M130.79 387.41h306.42M130.79 309.08h306.42M130.79 230.75h306.42M130.79 152.43h306.42M130.79 74.1h306.42M130.79-4.23" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { fill: "none", stroke: "#33691E", strokeMiterlimit: "10" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M130.79 504.9h306.42M130.79 426.57h306.42M130.79 348.24h306.42M130.79 269.92h306.42M130.79 191.59h306.42M130.79 113.26h306.42M130.79-43.39" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "hobbit-hobbit" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M238.89 195.42c-10.69-16.96 9.62-31.65 19.92-22.63 1.14 1 2.94.46 3.26-1.03 2.43-11.25 15.75-22.28 23.53-10.45 1.28 1.94 4.23 1.67 5.12-.48 4.1-9.94 14.27-14.07 20.58-5.28 1.53 2.13 4.69 1.96 5.99-.32 7.27-12.85 20.66-7.04 20.62 6.21-.01 3.67 3.22 6.49 6.81 5.82 11.86-2.19 20.27 5.75 14.96 17.66-1.43 3.21.39 6.95 3.8 7.75 10.86 2.55 14.46 11.15 6.59 16.89-2.42 1.76-1.99 5.51.72 6.76 14.49 6.66 15.99 23.13-.87 21.05-2.06-.25-3.46 2.03-2.32 3.77 6.02 9.23 1.41 15.93-9.01 15.47-2.73-.12-4.81 2.39-4.26 5.08 2 9.85-2.9 15.41-12.71 13.17-2.96-.67-5.9 1.01-7.03 3.84-4.04 10.2-13.91 6.94-20.96-4.47-.63-1.02-2.16-.72-2.38.45-3.03 15.78-16.42 12.1-21.94-1.22-.87-2.11-3.56-2.69-5.25-1.17-11.83 10.63-26.29 6.92-19.46-8.42.3-.68-.52-1.28-1.08-.81-14.96 12.62-37.92-2.59-20.58-14.39 1.29-.88.76-2.88-.79-3-12.46-.98-17.62-11.71-7.92-18.48 2.51-1.75 2.75-5.37.63-7.57-10.19-10.59 11.54-12.29 4.03-24.2z",
            fill: "#3E2723"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M345.69 284.81l-44.25 17.58-43.77-19.55 2.87-.3c12.41-1.31 21.83-11.77 21.83-24.25h38.76v1.88c0 12.15 8.95 22.45 20.98 24.14l3.58.5zM318.49 457.07l4.28 23.7c.46 2.57 1.13 5.09 2 7.55l9.72 27.42h20.27l-1.07-62.23-35.2 3.56z",
            fill: "#FFD596"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M325.32 527.45c-.57 2.54-.85 6.16-.24 8.09.38 1.2 1.73 3.42 2.65 4.27 1.98 1.82 6.52 4.03 9.96 4.03h4.95c1.85 0 3.68-.3 5.43-.89l6-2.03c1.76-.6 3.66-.69 5.47-.27l8.8 2.02c3.39.78 6.87 1.18 10.35 1.18h6.09c1.94 0 3.83-.57 5.45-1.65l1-.67c1.43-.95 3.3-.9 4.67.11l.15.11c1.84 1.36 4.06 2.09 6.34 2.09h.74c2.7 0 5.29-1.1 7.16-3.04 2.47-2.57 3.53-6.19 2.81-9.68-.27-1.31-1.37-2.29-2.71-2.4l-5.38-.45c-5.46 1-6.2-1.4-8.45-2.37l-4.82-2.08c-2.18-1.21-4.44-2.25-6.77-3.11-5.98-2.21-18.48-7.06-24.98-11.23L348 501.79l-5.51-.6c-5.3-.58-9.95 3.54-10.02 8.87-.61 2.79-1.05 5.54-2.36 8.08-1.99 3.89-4.79 9.31-4.79 9.31z",
            fill: "#FFD596",
            id: "hobbit-foot-right"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M281.51 457.07l-4.28 23.7c-.46 2.57-1.13 5.09-2 7.55l-9.72 27.42h-20.27l1.07-62.23 35.2 3.56z",
            fill: "#FFD596"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M274.68 527.45c.57 2.54.85 6.16.24 8.09-.38 1.2-1.73 3.42-2.65 4.27-1.98 1.82-6.52 4.03-9.96 4.03h-4.95c-1.85 0-3.68-.3-5.43-.89l-6-2.03c-1.76-.6-3.66-.69-5.47-.27l-8.8 2.02c-3.39.78-6.87 1.18-10.35 1.18h-6.09c-1.94 0-3.83-.57-5.45-1.65l-1-.67c-1.43-.95-3.3-.9-4.67.11l-.15.11c-1.84 1.36-4.06 2.09-6.34 2.09h-.74c-2.7 0-5.29-1.1-7.16-3.04-2.47-2.57-3.53-6.19-2.81-9.68.27-1.31 1.37-2.29 2.71-2.4l5.38-.45c5.46 1 6.2-1.4 8.45-2.37l4.82-2.08c2.18-1.21 4.44-2.25 6.77-3.11 5.98-2.21 18.48-7.06 24.98-11.23l12.01-7.69 5.51-.6c5.3-.58 9.95 3.54 10.02 8.87.61 2.79 1.05 5.54 2.36 8.08 1.97 3.89 4.77 9.31 4.77 9.31z",
            fill: "#FFD596",
            id: "hobbit-foot-left"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M361.57 351.15l-11.93-18.61 3.02 26c.65 5.61.27 11.28-1.11 16.75l-3.78 14.93h-95.54l-3.78-14.93c-1.39-5.47-1.76-11.15-1.11-16.75l3.02-26-11.93 18.61-25.2-16.56 20.34-34.13c2.06-3.46 4.97-6.35 8.44-8.4l15.66-9.22 34.94 8.19 7.39 6.04 7.01-5.91 35.33-8.31 15.66 9.22c3.47 2.05 6.38 4.93 8.44 8.4l20.34 34.13-25.21 16.55z",
            fill: "#FFEE58"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#FFD596",
            d: "M292.61 291.02l7.39 60.44 7.01-60.31-7.01 5.91z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#33691E",
            d: "M347.77 390.22l8.02 18.34 9.64 54.2h-56.89L300 430.38l-8.53 32.38h-56.9l9.44-53.76 8.22-18.78z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#5D4037",
            d: "M351.47 287.09l-11.91 94.95h-9.25l12.02-99.21z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#FFF176",
            d: "M307.01 291.15l8.72 15.68 26.6-24-4.97-3.27z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#8D6E63", d: "M330.31 382.04l3.82 15.65 5.43-15.65z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "334.13", cy: "395.2", rx: "2.22", ry: "2.49", fill: "#BDBDBD" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#5D4037",
            d: "M247.54 287.09l11.91 94.95h9.25l-12.02-99.21z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#8D6E63", d: "M268.7 382.04l-3.82 15.65-5.43-15.65z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#FFF176",
            d: "M292.65 291.15l-8.72 15.68-27.25-24 3.57-3.27z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "264.88", cy: "395.2", rx: "2.22", ry: "2.49", fill: "#BDBDBD" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M269.33 358.01l2.43 14.7c.52 3.16-1.52 6.07-4.58 6.54l-8.4 1.27c-2.52.38-5.12-.24-7.27-1.74l-8.02-5.6-31.86 3.5c-2.35.26-7.8-.76-7.9-3.19l-1.24-12.45c0-10.67 13.51-31.83 13.51-31.83l25.25 13.16c-.16 2.38-3.31 3.99-4.08 6.22l-8.36 9.37 14.39-.23 8.68-5.64c1.45-.94 3.19-1.36 4.94-1.19l5.74.58c3.39.37 6.2 3.06 6.77 6.53zM329.84 358.01l-2.43 14.7c-.52 3.16 1.52 6.07 4.58 6.54l8.4 1.27c2.52.38 5.12-.24 7.27-1.74l8.02-5.6 31.86 3.5c2.35.26 7.8-.76 7.9-3.19l1.24-12.45c0-10.67-13.51-31.83-13.51-31.83l-25.25 13.16c.16 2.38 3.31 3.99 4.08 6.22l8.36 9.37-14.39-.23-8.68-5.64c-1.45-.94-3.19-1.36-4.94-1.19l-5.74.58c-3.39.37-6.2 3.06-6.77 6.53z",
            fill: "#FFD596"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M278.74 271.08c19.21 22.11 45.93 1.74 45.93 1.74l-1.33-5.14c-.61-2.35-1.29-4.69-2.04-7l-.17-.52H282.3c-.47 2.83-1.28 5.59-2.4 8.23l-1.16 2.69z",
            fill: "#C7A97D"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#FFF176",
            d: "M245.24 341.76l-29.79-15.99-5.11 9.33 27.94 16.05z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M259.45 390.22l-.49 6.11c-.54 6.63-3.75 12.75-8.89 16.96l-7.95 6.51 1.9-10.79 8.22-18.79h7.21zM340.58 390.22l.49 6.11c.54 6.63 3.75 12.75 8.89 16.96l7.95 6.51-1.9-10.79-8.22-18.79h-7.21z",
            fill: "#1F3D12"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#FFF176",
            d: "M354.26 341.76l29.78-15.99 5.12 9.33-27.95 16.05z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M377.08 405.02c-1.39 1.67-2.76 2.56-3.91 3.03-1.79.74-4.02.33-5.2-.15-.33-.14-.65-.29-.96-.46l-4.2-2.31-9.4 10.97-3.85-3.15-1.28-1.17 10.1-10.57-2.8-3.89c-.21-.29-.4-.59-.57-.9-.63-1.12-1.3-3.28-.78-5.15.33-1.19 1.05-2.66 2.53-4.25l7.53-8.75 2.99 2.65-7.01 8.52c-.45.55-.84 1.15-1.11 1.81 0 .02-.01.03-.02.05-.73 1.79-.37 3.83.88 5.3l2.23 2.6c.61.71 1.31 1.33 2.09 1.85l2.85 1.89c1.61 1.06 3.68 1.17 5.36.23.02-.01.03-.02.04-.02.62-.35 1.17-.81 1.67-1.32l7.61-7.99 2.99 2.65-7.78 8.53z",
            fill: "#795548"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#212121",
            d: "M359.19 384.19l3.12-3.56 3.12 2.52-3.12 3.8zM380.07 395.71l3.1 2.62-3.25 3.56-3.24-2.62z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M361.7 382.72l1.1 1.07c1.88 1.05 2.4 3.02 3.11 5.05l1.56 4.41c.72 2.05.92 4.26.57 6.41l-.46 2.78c-.46 2.79-.01 5.65 1.28 8.17l1.41 2.76-1.91.19-1.49-3.06c-1.19-2.45-1.6-5.2-1.17-7.88l.42-2.65c.36-2.22.12-4.5-.67-6.61l-1.38-3.65c-.65-1.73-1.25-3.61-2.79-4.64l-.88-1.01 1.3-1.34zM381.61 398.8l.64 1c1.91 3 2.39 6.68 1.32 10.06l-.53 1.68c-.87 2.77-3.07 4.92-5.85 5.73-.11.03-.23.05-.35.07l-.66.07-.8-1.33.48-.15c2.56-.79 4.62-2.71 5.58-5.22 1.37-3.59.94-7.63-1.17-10.85l-.15-.24 1.49-.82z",
            fill: "#212121"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M369.69 411.75l.58.08.97.13c.92.12 1.8.42 2.6.89l.3.17c.82.48 1.54 1.12 2.11 1.88l.92 1.24c-.28 1.4-1.5 2.4-2.92 2.4h-.29c-.34 0-.68-.06-1-.17l-2.19-.78c-.68-.24-1.25-.72-1.6-1.35l-.65-1.16c-.32-.57-.44-1.24-.35-1.89l.21-1.43h1.31z",
            fill: "#212121"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M344.65 225.95c0 13.5-13.01 27.59-22.22 39.45-9.69 12.48-31.09 11.15-40.84-.98-9.79-12.17-20.63-24.71-20.63-38.47 0-24.15 18.74-43.73 41.85-43.73s41.84 19.58 41.84 43.73z",
            fill: "#FFD596"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M313.67 222.51l1.35-1.96c1.97-2.87 5.49-4.25 8.88-3.48l1.35.3c2.58.58 4.75 2.33 5.86 4.73.62 1.35-.45 2.86-1.92 2.73l-15.05-1.34c-.49-.05-.74-.59-.47-.98z",
            fill: "#FFF"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "322.42", cy: "220.49", r: "3.64", fill: "#388E3C" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M293.95 222.15l-1.35-1.96c-1.97-2.87-5.49-4.25-8.88-3.48l-1.35.3c-2.58.58-4.75 2.33-5.86 4.73-.62 1.35.45 2.86 1.92 2.73l15.05-1.34c.49-.04.74-.58.47-.98z",
            fill: "#FFF"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "285.2", cy: "220.13", r: "3.64", fill: "#388E3C" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#5D4037",
            d: "M311.46 211.67l.89-4.25 18.94.04 7.38 2.62 2.25 3.5-10.43-1.77zM295.45 211.91l-.89-4.25-19.5.04-6.82 2.61-.52 3.03 7.57-1.3z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M302.8 173.24l2.21 18.97 9.6 4.11c5.01 2.15 12.13 10.49 17.33 13.87 2.39 1.56 4.38 3.65 5.78 6.14l4.61 8.16 20.81-7.63-34.2-29.43-26.14-14.19z",
            fill: "#3E2723"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M308.2 173.24l-3.19 18.97s-10.87 3.64-14.08 5.66c-7.03 4.41-11.19 12.11-18.39 16.17-2.78 1.57-5.26 3.62-7.42 5.98l-5.37 5.9-4.79-27.77 53.24-24.91z",
            fill: "#3E2723"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            fill: "#C7A97D",
            d: "M295.2 238.53h14.7l1.6 2.84-8.66 2.83-9.45-2.83z"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "#FFF", d: "M288.61 252.12h28.05l-14.22 8.04z" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M338.22 230.71l3.74-4.63c2.45-3.04 5.55-5.5 9.06-7.2l.74-.36c.57-.43 1.39-.03 1.39.69v4.75c0 4.56-1.87 8.93-3.6 13.15l-2.26 5.51c-.88 2.14-3.36 3.12-5.46 2.16-.76-.35-1.3-1.04-1.45-1.87l-2.16-12.2zM265.59 230.71l-3.74-4.63c-2.45-3.04-5.55-5.5-9.06-7.2l-.74-.36c-.57-.43-1.39-.03-1.39.69v4.75c0 4.56 1.87 8.93 3.6 13.15l2.26 5.51c.88 2.14 3.36 3.12 5.46 2.16.76-.35 1.3-1.04 1.45-1.87l2.16-12.2z",
            fill: "#FFD596"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M378.5 512.46c.23-3.03 12.14-2.25 8.64 3.84-.05.09.11.18.19.11 4.75-3.54 8.78 3.68 4.88 4.01l-1.13.01c4.81.49 5.12 6.67-.73 3.33-.23-.13.6.39.93.91 2.11 3.29-5.08 5.44-8.71-.38.29 3.5-9.98 3.14-10.08-1.86 0 0-.26.3-.65.76-1.42 1.68-3.97 1.2-5.74.11-.92-.57-1.62-1.17-1.77-2.19-.07-.46.94-1.71.94-1.71s-9.38 2.16-8.27-2.54c.05-.21.45-.69.59-.94.44-.79 3.05-.83 3.05-.83l-.67-.15c-.82-.16-1.61-.52-2.21-1.03-2.76-2.32 2.45-5.94 6.16-2.53 0 0-.89-.95-1.01-1.3-1-3.15 4.64-4.16 7.14.1.15.26.33.26.37 0 .16-1.07.72-2.8 3.55-2.76 5.52.08 4.53 5.04 4.53 5.04zM222.74 512.46c-.23-3.03-12.14-2.25-8.64 3.84.05.09-.11.18-.19.11-4.75-3.54-8.78 3.68-4.88 4.01l1.13.01c-4.81.49-5.12 6.67.73 3.33.23-.13-.6.39-.93.91-2.11 3.29 5.08 5.44 8.71-.38-.29 3.5 9.98 3.14 10.08-1.86 0 0 .26.3.65.76 1.42 1.68 3.97 1.2 5.74.11.92-.57 1.62-1.17 1.77-2.19.07-.46-.94-1.71-.94-1.71s9.38 2.16 8.27-2.54c-.05-.21-.45-.69-.59-.94-.44-.79-3.05-.83-3.05-.83l.67-.15c.82-.16 1.61-.52 2.21-1.03 2.76-2.32-2.45-5.94-6.16-2.53 0 0 .89-.95 1.01-1.3 1-3.15-4.64-4.16-7.14.1-.15.26-.33.26-.37 0-.16-1.07-.72-2.8-3.55-2.76-5.51.08-4.53 5.04-4.53 5.04z",
            fill: "#5D4037"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          id: "hobbit-man",
          d: "M306.13 298.37l-1.39 11.55-2.84 20.65c-.1.75-.08 1.5.09 2.23l2.08 9.58c.43 1.95.14 3.99-.83 5.77l-4.9 9.02c-1.07 1.95-3.15 3.23-5.48 3.33l-1.46.06c-2.4.1-4.75-.7-6.52-2.24l-.62-.55c-1.29-1.12-1.65-2.9-.9-4.4l2.22-4.42c.24-.47.41-.97.51-1.48l1.17-5.8c.12-.61-.15-1.27-.74-1.54-2.41-1.13-2.31 6.9-2.31 6.9.19 2.63-2.21 2.95-2.49-.07l-.4-9.77c-.05-1.21.34-2.4 1.11-3.37l5.58-7.01c1.68-2.11 2.4-4.78 2-7.39l-5.35-34.93-2.99-40.66-2.56-20.66c-5.23 11.92-8.09 24.66-8.44 37.56l-.1 3.68 7 42.91c1.03 6.26 1.12 12.63.29 18.91l-4.72 35.71-8.11 38.74-.68 21.12c-.11 3.67-.03 7.34.26 11l.85 11.03v3.57c0 10.47-1.51 20.9-4.48 31l-9.18 31.18-1.77 8.67c-.08.4-.12.8-.12 1.19 0 .8.15 1.59.47 2.33 1.48 3.48 4.67 8.5 6.59 11.41 1.06 1.59 1.86 3.31 2.4 5.12l.12 3.08c.06 1.36-1.09 2.49-2.53 2.49H235.6c-3.27 0-5.77-2.75-5.28-5.8l.48-2.99 1.79-4.93 1.12-6.23c1.52-8.46 1.99-17.06 1.38-25.62l-2.33-32.85c-.11-1.52-.13-3.03-.05-4.54l1.13-21.57c.03-.51.03-1.02.01-1.54L230 334.53l-3.81 103.3c-.03.52-.02 1.03.01 1.54l1.13 21.57c.08 1.52.06 3.03-.05 4.54l-2.33 32.85c-.62 8.56-.15 17.16 1.38 25.62l1.12 6.23 1.79 4.93.48 2.99c.5 3.05-2.01 5.8-5.28 5.8h-21.36c-1.43 0-2.59-1.12-2.53-2.49l.12-3.08c.54-1.81 1.34-3.53 2.4-5.12 1.91-2.9 5.11-7.93 6.59-11.41.32-.74.47-1.53.47-2.33 0-.4-.04-.8-.12-1.19l-1.77-8.67-9.18-31.18c-2.97-10.09-4.48-20.53-4.48-31v-3.57l.85-11.03c.29-3.65.37-7.33.26-11l-.68-21.12-8.11-38.74-4.72-35.71c-.83-6.29-.73-12.65.29-18.91l7-42.91-.1-3.68c-.35-12.9-3.21-25.63-8.44-37.56l-2.56 20.66-2.99 40.66-5.35 34.93c-.4 2.61.32 5.28 2 7.39l5.58 7.01c.77.97 1.16 2.16 1.11 3.37l-.4 9.77c-.28 3.03-2.68 2.7-2.49.07 0 0 .1-8.03-2.31-6.9-.59.27-.86.93-.74 1.54l1.17 5.8c.1.51.27 1.01.51 1.48l2.22 4.42c.75 1.49.39 3.28-.9 4.4l-.62.55c-1.77 1.54-4.12 2.35-6.52 2.24l-1.46-.06c-2.32-.1-4.41-1.38-5.48-3.33l-4.9-9.02c-.97-1.77-1.26-3.82-.83-5.77l2.08-9.58c.16-.73.19-1.48.09-2.23l-2.84-20.65-1.39-11.55c-1.34-11.09-1.36-22.28-.03-33.38l1.85-15.58 1.28-41.55 2.36-17.96c1.12-6.77 3.37-12.1 7.03-18.02 1.54-2.47 3.45-4.69 5.68-6.58 2.23-1.89 4.76-3.47 7.52-4.65l7.51-3.21c4.42-1.89 8.98-3.48 13.63-4.77l4.62-1.27c3.77-1.04 6.64-3.94 7.49-7.56 1-4.2 1.81-6.74 2.26-11.05l-.01-1.3c0-.23-.26-.61-.63-1.04-1.61-1.87-3-4.62-3.61-6.31-.67-1.86-1.49-4.9-2.12-7.78l-1.29.38c-.8.23-1.62-.29-1.71-1.07l-.64-6.04-.79-6.28c0-.71.61-1.29 1.36-1.29.54 0 1.3.22 1.52.68l1.04 1.43c.06-.55.05-1.51.03-2.43-.06-1.97-.02-3.93.16-5.89.29-3.25.69-8.03 1.51-10.76 1.86-6.2 12.52-11.09 20.54-10.62 6.23.37 16.28 1.01 19.76 10 .85 2.19 1.27 6.21 1.73 9.53.43 3.04.35 6.11-.05 9.15-.05.39-.07.75-.04 1.02l1.04-1.43c.22-.46.98-.68 1.52-.68.75 0 1.36.58 1.36 1.29l-.79 6.28-.64 6.04c-.09.78-.91 1.3-1.71 1.07l-1.29-.38c-.62 2.88-1.44 5.91-2.12 7.78-.61 1.69-2 4.44-3.61 6.31-.37.43-.63.81-.63 1.04l-.01 1.3c.45 4.3 1.26 6.85 2.26 11.05.85 3.62 3.72 6.52 7.49 7.56l4.62 1.27c4.66 1.29 9.21 2.88 13.63 4.77l7.51 3.21c2.76 1.18 5.29 2.76 7.52 4.65 2.23 1.9 4.14 4.11 5.68 6.58 3.66 5.91 5.91 11.25 7.03 18.02l2.36 17.96 1.28 41.55 1.85 15.58c1.27 11.06 1.25 22.25-.09 33.35z",
          opacity: "0"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300",
          fill: "none"
        })
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 28.c45f98ebc39c2c7a38f4.js